'use strict'

module.exports = heading

var all = require('../all')

/* Transform a heading. */
function heading(h, node) {
  return h(node, 'h' + node.depth, all(h, node))
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-react/~/mdast-util-to-hast/lib/handlers/heading.js
// module id = 892
// module chunks = 95715928098905 168707334958949